import dayjs from "dayjs";
import { KPIItem } from "../../components/Business/StatsKPIGroup";
import { TrafficQualityTrendStatsEntity } from "../../types/entity/traffic-quality";

export const kpiFromStats = (s: TrafficQualityTrendStatsEntity | undefined ): KPIItem[] => {
  if (!s) return [];
  return [
    { title: '总进单量', value: s.totalOrders },
    { title: '实际发货率', value: s.avgShipmentRate, suffix: '%', precision: 2 },
    { title: '盲发订单数', value: s.blindShipOrders },
    { title: '通过订单数', value: s.riskPassOrders },
    { title: '预收订单数', value: s.prePaidOrders },
    { title: '高风险订单数', value: s.highRiskOrders },
  ];
};

export const getDefaultQuery = (appendQuery?: any) => {
  const today = dayjs().startOf('day');
  const weekStart = '2024-12-20';
  const weekEnd = today.subtract(1, 'day').format('YYYY-MM-DD');
  let baseFilter = { order: { orderCreatedAt: { operator: 'between', value: [weekStart, weekEnd] } }}
  return { filter: { 
    ...baseFilter, 
    ...appendQuery 
  } } as any;
};